import apiService from '../api'

export interface PaginationMeta {
  page: number
  limit: number
  total: number
  totalPages: number
}

export type NotificationType = 'info' | 'warning' | 'error' | 'success'

export interface NotificationApi {
  id: string
  userId: string
  type: NotificationType
  title: string
  message: string
  read: boolean
  link: string | null
  createdAt: string
}

export interface NotificationsListResponse {
  notifications: NotificationApi[]
  meta: PaginationMeta
}

export interface UnreadCountResponse {
  unreadCount: number
}

export async function getNotifications(params?: {
  page?: number
  limit?: number
  unreadOnly?: boolean
}): Promise<NotificationsListResponse> {
  const searchParams = new URLSearchParams()
  if (params?.page != null) searchParams.set('page', String(params.page))
  if (params?.limit != null) searchParams.set('limit', String(params.limit))
  if (params?.unreadOnly === true) searchParams.set('unreadOnly', 'true')
  const query = searchParams.toString()
  // Use dashboard endpoint so it works with optional auth and avoids 404 from /api/notifications
  const url = query ? `/dashboard/notifications?${query}` : '/dashboard/notifications'
  const res = await apiService.get<{ data?: NotificationsListResponse } & NotificationsListResponse>(url)
  const data = (res as { data?: NotificationsListResponse })?.data ?? res
  return {
    notifications: data.notifications ?? [],
    meta: data.meta ?? { page: 1, limit: 20, total: 0, totalPages: 0 },
  }
}

export async function getUnreadCount(): Promise<number> {
  try {
    // Use dashboard endpoint so it works with or without the dedicated /notifications module (avoids 404)
    const res = await apiService.get<{ success?: boolean; data?: UnreadCountResponse }>('/dashboard/notifications/unread-count')
    const data = ((res as { data?: UnreadCountResponse })?.data ?? res) as UnreadCountResponse
    return typeof data?.unreadCount === 'number' ? data.unreadCount : 0
  } catch {
    return 0
  }
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiService.patch(`/notifications/${id}/read`)
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiService.post('/notifications/mark-all-read')
}
